var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrain1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.746 34.6816C9.27551 35.5996 6.83209 36.8077 5.14202 37.7139C1.75536 39.7622 2.58946 39.0824 5.14202 37.7139C5.35966 37.5822 5.59473 37.4393 5.84789 37.2846C6.05138 37.1603 6.25311 37.0405 6.45308 36.9252C9.47134 34.9618 12.7158 30.2246 5.12419 24.2597C-5.00642 16.2999 6.94527 18.7759 5.12432 9.06428C2.34063 0.275278 18.8729 -0.343337 18.1493 2.55112C17.4256 5.44558 15.9784 9.06366 24.6618 9.78727C33.3452 10.5109 27.5562 14.1289 26.109 27.154C24.9019 38.0183 20.6741 32.269 11.746 34.6816Z",
    fill: "url(#paint0_linear_40495_3158)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2451 34.1166C15.6622 30.0161 -4.57216 43.6524 5.84789 37.2846M5.84789 37.2846C18.8729 29.3249 24.6618 40.1791 26.109 27.154C27.5562 14.1289 33.3452 10.5109 24.6618 9.78727C15.9784 9.06366 17.4256 5.44558 18.1493 2.55112C18.8729 -0.343337 2.34063 0.275278 5.12432 9.06428C6.94527 18.7759 -5.00642 16.2999 5.12419 24.2597C13.2287 30.6275 8.98352 35.5962 5.84789 37.2846Z",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0075 22.2861C13.8368 23.7334 15.6822 26.3934 16.9184 27.5582C17.705 28.2995 18.4362 29.134 19.5646 29.2366C21.3002 29.3944 22.3071 28.543 23.1169 27.1258",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55856 27.5278C8.46099 26.1618 7.5272 23.5187 8.45559 22.2971C9.12873 21.4114 10.7284 20.1143 11.8947 20.1143",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3406 8.04297C10.5527 9.06136 11.2833 9.96572 11.6482 10.9466C12.0474 12.0192 12.7754 13.2829 13.9032 13.7473C14.5539 14.0152 15.9007 13.4355 15.9007 12.6764",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5869 11.9088C12.8001 10.0614 13.1842 7.27539 15.5523 7.27539",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40495_3158",
    x1: 4.09057,
    y1: -11.7247,
    x2: 4.09057,
    y2: 57.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain1);
export default __webpack_public_path__ + "static/media/brain-1.bd4ccca4d44cebdbb8e86b937cfe5bdf.svg";
export { ForwardRef as ReactComponent };